import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubtleBadge from "components/common/SubtleBadge";
import { useAuth } from "contexts/AuthContext";
import useFormattedDate from "hooks/useFormatDate";
import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

export const TagUpdateModal = ({
  selectedTag,
  loading,
  showUpdateModal,
  setShowUpdateModal,
  updateTag,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAuth();
  const { formatDateTime } = useFormattedDate();

  useEffect(() => {
    if (selectedTag) {
      setName(selectedTag.name || "");
      setDescription(selectedTag.description || "");
    }
  }, [selectedTag]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedTag) return;

    const updatedData = {
      ...selectedTag,
      name: name.trim(),
      description: description.trim(),
    };

    try {
      setIsSubmitting(true);
      await updateTag(selectedTag.id, updatedData);
      setShowUpdateModal(false);
      // Reset form
      setName("");
      setDescription("");
    } catch (err) {
      console.error("Error updating tag:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    if (selectedTag) {
      setName(selectedTag.name || "");
      setDescription(selectedTag.description || "");
    }
  };

  const handleClose = () => {
    setShowUpdateModal(false);
    resetForm();
  };

  return (
    <Modal
      show={showUpdateModal}
      onHide={handleClose}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Update Tag
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.83rem" }}>

        <>

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter tag name"
                required
                maxLength={50}
              />

            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter tag description (optional)"
                maxLength={200}
              />

            </Form.Group>

            <div className="d-flex justify-content-end align-items-center gap-2 mt-4">
              <Button
                size="sm"
                variant="secondary"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </Button>

              {isSubmitting ? (
                <Spinner animation="border" size="sm" variant="success" />
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  variant="success"
                  disabled={!name.trim() || loading}
                >
                  Update Tag
                </Button>
              )}
            </div>
          </Form>
        </>

      </Modal.Body>
    </Modal>
  );
};